(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

$(function () {
  $('.btn-search-toggle').on('click', function (e) {
    e.preventDefault();
    $('.search-window').toggleClass('show-search').find('.search-input').trigger('focus');
    $('#page-blur').toggleClass('active');
  }); // let timer = null;
  // $('[cursor]').each((i,e)=>{
  //     var element = $(e);
  //     var cursorDiv = $('<div class="cursor"></div>');
  //     var cursorSymbole = element.attr('cursor');
  //     var textDiv = $('<span class="text" role="input"></span>');
  //     var symbolDiv = $('<div class="symbol"></div>');
  //     cursorDiv.append(textDiv);
  //     cursorDiv.append(symbolDiv);
  //     symbolDiv.text(cursorSymbole)
  //     var maxWidth = $(e).width();
  //     textDiv.attr('style', 'max-width: ' + maxWidth + 'px');
  //     element.parent().prepend(cursorDiv);
  //     element.on('focusin',(event)=>{
  //         symbolDiv.addClass('animate').addClass('show');
  //         element.attr('data-placeholder',element.attr('placeholder'));
  //         element.attr('placeholder','');
  //     })
  //     element.on('blur', (event)=>{
  //         if (!event.currentTarget.value){
  //             symbolDiv.removeClass('show');
  //         }
  //         symbolDiv.removeClass('animate');
  //         element.attr('placeholder',element.attr('data-placeholder'));
  //     })
  //     element.on('keyup keydown',(event)=>{
  //         cursorDiv.hide();
  //         clearTimeout(timer);
  //         timer = setTimeout( (event)=> {
  //             textDiv.html(element.val().replace(/ /g, '&nbsp;'));
  //             cursorDiv.show();
  //         } ,100)
  //         cursorDiv.click(function(event){
  //             event.preventDefault();
  //             element.focus();
  //         });
  //     })
  // })
});

},{}],2:[function(require,module,exports){
"use strict";

require("./components/search-window");

},{"./components/search-window":1}]},{},[2]);
